import React from 'react';
import { TableCell, Box } from '@mui/material';
import DutyTypeBadge from './DutyTypeBadge';

/**
 * ScheduleCell - individual cell in the schedule calendar
 * @param {Object} schedule - schedule data { id, duty_type_id, duty_type: {...} }
 * @param {function} onClick - click handler
 * @param {boolean} disabled - whether cell is clickable
 */
const ScheduleCell = ({ schedule, onClick, disabled = false }) => {
  return (
    <TableCell
      align="center"
      onClick={disabled ? undefined : onClick}
      sx={{
        cursor: disabled ? 'default' : 'pointer',
        '&:hover': disabled ? {} : {
          backgroundColor: 'action.hover'
        },
        padding: 1,
        minHeight: 40
      }}
    >
      {schedule?.duty_type ? (
        <DutyTypeBadge dutyType={schedule.duty_type} />
      ) : (
        <Box sx={{ height: 24 }} />
      )}
    </TableCell>
  );
};

export default ScheduleCell;
